import React from "react";
//#region types
//#endregion
//#region components
import { Skeleton } from "@mui/material";
//#endregion

const ViewPanelContentSkeleton: React.FC = (props) => {
  return <Skeleton width="100%" height="100px" variant="rectangular" />;
};

export default ViewPanelContentSkeleton;
